import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React from 'react';

import useCustomPropertyTypeFilterEffect from "./useCustomPropertyTypeFilter.hook";

type Props = {
  error?: any;
  value?: any | null | string;
  onChange?: (customPropertyType: any | null) => void;
  placeholder?: string;
  idSelectOnly?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
  id?: string;
  textFieldID?: string;
}

type CustomPropertyTypeValue = any | null | undefined;

export const CustomPropertyTypeFilter = ({
  error,
  placeholder,
  onChange,
  value,
  idSelectOnly = true,
  disabled,
  size = 'small',
  id = 'custon_property_type_filter',
  textFieldID = 'txt_custom_property_type'
}: Props) => {
  const {
    customPropertyTypeList,
    loading,
  } = useCustomPropertyTypeFilterEffect();

  const onSelectChange = (_: any, customPropertyType: any) => {
    if (!customPropertyType) {
      return;
    }
    onChange?.(idSelectOnly ? (customPropertyType?.id ?? '') : customPropertyType);
  };

  const selectedValue: CustomPropertyTypeValue = idSelectOnly ? customPropertyTypeList?.find((item: any) => item.id === value) ?? null : value as CustomPropertyTypeValue;

  return (
    <Autocomplete
      id={id}
      options={customPropertyTypeList || []}
      getOptionLabel={(option: any) => option?.name ?? ''}
      isOptionEqualToValue={(option: any, selected: any) => option?.name === selected?.name}
      onChange={onSelectChange}
      value={selectedValue ?? {}}
      size={size}
      disabled={disabled || loading}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        );
      }}
      renderInput={(params) => (
        <>
          <TextField
            {...params}
            placeholder={placeholder}
            variant="outlined"
            label={placeholder}
            id={textFieldID}
            error={!!error}
            helperText={error?.message ?? ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        </>
      )}
    />
  );
};

export default CustomPropertyTypeFilter;